import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

const Challenge = () => {
  useEffect(() => {
    AOS.init({
      once: false,
      duration: 800,
      easing: 'ease-out'
    });
  }, []);

  return (
    <section className="lg:py-16 lg:px-12 px-5 py-12 bg-bgDefault text-white">
      <div className="container mx-auto max-w-screen-xl overflow-hidden">
        {/* Header */}


        {/* Content Container */}
        <div className="lg:px-[168px]">
          {/* Description */}
          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
            data-aos="fade-down"
          >
            The Challenge
          </h2>

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            A leading Australian media company struggled with delayed campaign performance insights that prevented
            advertisers from making timely optimization decisions. Their legacy analytics system processed data in batches,
            creating hours-long delays between campaign events and performance reporting. Manual report generation consumed
            excessive analyst time, campaigns couldn't be monitored during peak hours due to system limitations, and the
            inability to handle high-volume data streams meant missing critical advertising opportunities during major events
            and product launches.
          </p>

          <h4
            className="text-xl font-semibold text-white mb-3"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            Key Challenges:
          </h4>
          <ul className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-8 lg:mb-12 list-disc pl-5 space-y-2">
            <li data-aos="fade-left" data-aos-delay="250">Processing millions of advertising events daily without performance degradation or data loss</li>
            <li data-aos="fade-left" data-aos-delay="300">Real-time dashboard updates requiring sub-second latency for impressions, clicks, conversions, and ROI metrics</li>
            <li data-aos="fade-left" data-aos-delay="350">High-volume data streams during peak advertising periods (holiday seasons, major events) overwhelming existing infrastructure</li>
            <li data-aos="fade-left" data-aos-delay="400">Manual reporting process consuming 50% of analyst time and delaying strategic decisions</li>
            <li data-aos="fade-left" data-aos-delay="450">Need for customized reports tailored to diverse client KPIs and reporting timeframes</li>
            <li data-aos="fade-left" data-aos-delay="500">Inability to track campaign performance across multiple channels in unified view</li>
            <li data-aos="fade-left" data-aos-delay="550">Integration requirements with various ad networks, social media platforms, and analytics tools</li>
            <li data-aos="fade-left" data-aos-delay="600">Scalability challenges requiring AWS cloud infrastructure with message queuing for reliability</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Challenge
